import { useContext } from "react";
import config from "../../config";
import { useMutation } from "@tanstack/react-query";
import { AppContext } from "@/App.context";


const setTaggings = (token) => {
  return async ({ body, service,type }) => {
    const endpoint = type === "edit" ? "update" : "create";
    const setTaggings = await fetch(
      `${config.apiHost}/v1/${service}/virtual-tag/${endpoint}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      }
    );

    if (!setTaggings.ok) {
      const errorResponse = await setTaggings.json();
      throw new Error(errorResponse.message);
    }
    const data = await setTaggings.json();

    return data;
  };
};

export const useCreateTagging = (type) => {
  const appContext = useContext(AppContext);

  const mutation = useMutation({
    mutationKey: ["setTaggings", type],
    mutationFn: (body) => setTaggings(appContext.idToken)({ ...body, type }),
  });

  return mutation;
};
